import { useMessageEditorTranslateButtonChange } from '../hooks/useMessageEditorTranslate';
import { SendButton } from '../MessageEditorFooter/SendButton';
import { TranslateButton } from '../MessageEditorFooter/TranslateButton';

interface LightMessageEditorFooterProps {
  conversation: Conversation.Conversation;
  targetLang: General.Language;
  translating: boolean;
  trimInput: string;
  sendBtnDisable: boolean;
  onTranslateClick: () => void;
  doSend: () => void;
  children: React.ReactNode;
}

export const LightMessageEditorFooter = (props: LightMessageEditorFooterProps) => {
  const {
    conversation,
    targetLang,
    translating,
    trimInput,
    sendBtnDisable,
    onTranslateClick,
    doSend,
    children,
  } = props;
  const { conversationId, region, channel, controlStatus } = conversation;

  const { onChange } = useMessageEditorTranslateButtonChange(conversationId, region);

  return (
    <div className="px-3 pb-2 flex items-center justify-between">
      {children}
      <div className="flex items-center gap-2">
        <TranslateButton
          region={region}
          channel={channel}
          controlStatus={controlStatus}
          targetLang={targetLang}
          onChange={onChange}
          translating={translating}
          trimInput={trimInput}
          onTranslateClick={onTranslateClick}
        />
        <SendButton translating={translating} sendBtnDisable={sendBtnDisable} doSend={doSend} />
      </div>
    </div>
  );
};
